/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Row_Has_ErrorInputs */

const vi_shop_home_row_has_error = /** @type {(inputs: Shop_Home_Row_Has_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có ô cần sửa — bấm Sửa để xem.`)
};

/**

* @param {Shop_Home_Row_Has_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_row_has_error = /** @type {((inputs?: Shop_Home_Row_Has_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Row_Has_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_row_has_error(inputs)
});